import React, { Component } from "react";
import "./ButtonGroup.css";
import axios from "axios";
import fileDownload from "react-file-download";

import "./DownloadButton.css";

// const Configuration = require("./shared/configuration");

class DownloadButton extends Component {
  constructor(props) {
    super(props);
    this.state = { exporting: false };
    this.getFile = this.getFile.bind(this);
  }

  getFile() {
    if (!this.state.exporting) {
      this.setState({ exporting: true });
      axios
        .get(this.props.url, { params: { s3: true }, responseType: "blob" })
        .then(response => {
          this.setState({ exporting: false });
          fileDownload(response.data, "hon" + this.props.suffix);
        });
    }
  }

  render() {
    return (
      <div
        className="DownloadButton OptionButton"
        onClick={() => this.getFile()}
      >
        {this.state.exporting ? this.props.exportingString : this.props.title}
      </div>
    );
  }
}
export default DownloadButton;



// WEBPACK FOOTER //
// ./src/DownloadButton.js